/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, leftValue: NonNullable<unknown>, leftMetric: NonNullable<unknown>, rightChain: NonNullable<unknown>, rightValue: NonNullable<unknown>, rightMetric: NonNullable<unknown> }} Chain_Page_Compare_CountsInputs */



/**
* | output |
* | --- |
* | "{leftChain} has {leftValue} {leftMetric}, while {rightChain} has {rightValue} {rightMetric}" |
*
* @param {Chain_Page_Compare_CountsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_counts = /** @type {((inputs: Chain_Page_Compare_CountsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_CountsInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} has ${i?.leftValue} ${i?.leftMetric}, while ${i?.rightChain} has ${i?.rightValue} ${i?.rightMetric}`)
});